module.exports = __webpack_public_path__ + "static/media/c11_1.52cf415e.png";